export default function CategoryInImage({part}) {
	if(part.isSponsored)
		part.category = 'Annonseinnhold';

	return <div className={['categoryInImage categoryBoxThemed', part.isSponsored?'sponsored':'', part.isOpinionPiece?'opinionPiece':''].join(' ')}>
		{part.category}
	</div>
}